import { Injectable } from '@angular/core';

import { ApiService }           from '../../app-lite/api/api.service';
import { JobModel }             from './models/job';
import { TableCountModel }      from '../table/models/table-count';
import { TablePaginationModel } from '../table/models/table-pagination';

@Injectable({
  providedIn: 'root'
})
export class JobsService {
  defaultPagination : TablePaginationModel = {
    enabled : true,
    offset  : 0,
    pageSize: 4
  };

  constructor (
    private apiService: ApiService
  ) {}

  getJobCount () : ng.IPromise<TableCountModel> {
    return this.apiService.get('/customer_portal_dashboard/open_jobs_count');
  }

  getJobs ( offset = this.defaultPagination.offset, pageSize = this.defaultPagination.pageSize ) : ng.IPromise<Array<JobModel>> {
    return this.apiService.get('/customer_portal_dashboard/open_jobs_index', [
      offset,
      pageSize
    ]);
  }
}
